import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";


function NotAuthorize() {
    return (
        <div className="not-found-container">
            <div className="not-found-content">
                <h2>404</h2>
                <h3>Not Authorized to access this page</h3>
                <p>Oops! The page you were looking for doesn`&apos;`t exist.</p>
                <Link to={-1} className="btn">
                    Back
                </Link>
            </div>
        </div>
    );
}

export default NotAuthorize;
